import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import SurveyAnalysis from "../../components/SurveyAnalysis";

const SurveyAnalysisPage = () => {
  const location = useLocation();
  const analysisData = location.state?.analysisData;

  // Redirect if no analysis data is available
  if (!analysisData) {
    return <Navigate to="/" replace />;
  }

  return <SurveyAnalysis analysisData={analysisData} />;
};

export default SurveyAnalysisPage;


